<div class="filmicFile">

  <div class="contenedor" *ngIf="filmicFile">
    <div class="fotoPrincipal">
      <div class="fondo"></div>
      <img src="{{ fotoPrincipal }}" />
    </div>

    <div class="row box ">
      <div class="col-12 info mb-2">
        <h2 class="title">{{ filmicFile.title }}</h2>
      </div>

      <div class="col-12 col-lg-8  info">
        <p class="elipsis-4" [innerHTML]="filmicFile.synopsis"></p>

        <a class="btn btn-light mt-4 text-dark" href="/movie/{{ filmicFile.id }}">
          <i class="fas fa-plus mr-2"></i> Más información
        </a>
      </div>

    </div>
  </div>
</div>